import { ComponentRendering, ComponentParams, Field } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

// Container types
export type N08TabsProps = RenderingProps<unknown, N08TabParams, TabsPlaceholder>;

export type TabsPlaceholder = {
  'tab-container'?: {
    uid?: string;
    componentName?: string;
    placeholders?: TabContentPlaceholder;
    fields?: N08TabFields;
  }[];
};

export type N08TabParams = {
  TitleSize?: string;
  HasShadow?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;

type TabContentPlaceholder = {
  'tab-content-container'?: {
    uid?: string;
    rendering?: ComponentRendering & { params?: ComponentParams };
  }[];
};

// Inner tab types
export type N08TabProps = RenderingProps<N08TabFields>;

export type N08TabFields = {
  TabTitle?: Field<string>;
};
